// extracted by mini-css-extract-plugin
export default {"illustrative-interactions":"list_illustrative-interactions__lT0UC"};